"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var http_type_1 = require("./http-type");

var react_redux_1 = require("react-redux");

var HTTP_STATE_KEY;

(function (HTTP_STATE_KEY) {
  HTTP_STATE_KEY["IS_LOADING"] = "isLoading";
  HTTP_STATE_KEY["IS_FAILED"] = "isFailed";
})(HTTP_STATE_KEY = exports.HTTP_STATE_KEY || (exports.HTTP_STATE_KEY = {}));

exports.INITIAL_HTTP_STATE = (_a = {}, _a[HTTP_STATE_KEY.IS_LOADING] = {}, _a[HTTP_STATE_KEY.IS_FAILED] = {}, _a);

exports.httpReducers = function (state, action) {
  var _a, _b;

  if (state === void 0) {
    state = exports.INITIAL_HTTP_STATE;
  }

  switch (action.type) {
    case http_type_1.HTTP_ACTION_TYPE.SET_LOADING:
    case http_type_1.HTTP_ACTION_TYPE.SET_FAILED:
      var key = action.type === http_type_1.HTTP_ACTION_TYPE.SET_LOADING ? HTTP_STATE_KEY.IS_LOADING : HTTP_STATE_KEY.IS_FAILED;
      var _c = action.payload,
          id = _c.id,
          result = _c.result;

      var _newState = __assign(__assign({}, state), (_a = {}, _a[key] = __assign(__assign({}, state[key]), (_b = {}, _b[id] = result, _b)), _a));

      if (!result) {
        delete _newState[key][id];
      }

      return _newState;

    default:
      return state;
  }
};

exports.useLoadingSelector = function (id) {
  return react_redux_1.useSelector(function (state) {
    return state.http['isLoading'][id];
  });
};

exports.useRequestFailedSelector = function (id) {
  return react_redux_1.useSelector(function (state) {
    return state.http['isFailed'][id];
  });
};

exports.useLoading = function (ignoreIds) {
  var isLoading = react_redux_1.useSelector(function (state) {
    return state.http['isLoading'];
  });

  var loading = __assign({}, isLoading);

  (ignoreIds || []).forEach(function (scope) {
    delete loading[scope];
  });
  return Object.keys(loading).length > 0;
};